import { render, staticRenderFns } from "./LaboratoryComponent.vue?vue&type=template&id=5751e7bc&"
import script from "./LaboratoryComponent.vue?vue&type=script&lang=js&"
export * from "./LaboratoryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports